import React from 'react'
import { Fragment, useState } from 'react'
import { Listbox, Transition } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'
import { normalizeTeacherName } from '../../teacherNameUtils'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function CalendarTeacherDropdown(props) {
  const [selected, setSelected] = useState({Name: 'Select Teacher', ImageName: 'none'})

  const buildTeacherImageUrl = (imageName) => {
    if (!imageName || imageName === 'none') return ''
    return String(imageName).startsWith("https")
      ? `${imageName}`
      : `https://app.atharo.app/images/${imageName}`
  }

  React.useEffect(() => {
    props.newEvent.teacherName === '' ? setSelected({Name: 'Select Teacher', ImageName: 'none'}) : setSelected({Name: props.newEvent.teacherName, ImageName: props.newEvent.teacherImageUrl})
  }, [])

    // React.useEffect(() => {
    //     props.setNewEvent({...props.newEvent, teacherName: selected.Name, teacherId: selected.TeacherID, teacherImageUrl: selected.ImageName.startsWith("https") ? `${selected.ImageName}` : `https://app.atharo.app/images/${selected.ImageName}`})
    // }, [selected])

    const changingSomething = (e) => {
      const nextImageName = e.ImageName || e.imageName || 'none'
      const teacherName = normalizeTeacherName(e.Name)
      setSelected({Name: teacherName, ImageName: nextImageName})
      props.setSomethingWasChanged(true)
      props.setNewEvent({
        ...props.newEvent,
        teacherName,
        teacherId: e.TeacherID,
        teacherImageUrl: buildTeacherImageUrl(nextImageName),
      })
    }

  return (
    <div>
      <Listbox value={selected} onChange={(e) => changingSomething(e)}>
        {({ open }) => (
          <>
            <Listbox.Label className="block text-sm font-medium text-gray-700">Teacher:</Listbox.Label>
            <div className="relative mt-1">
              <Listbox.Button className={classNames((props.attemptedSave && props.newEvent.teacherId === '') ? 'border-red-500 border-2 text-red-500' : 'border-gray-300 text-black', "relative w-full cursor-default rounded-md border bg-white py-2 pl-3 pr-10 text-left shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 sm:text-sm")}>
                <span className="flex items-center">
                  {selected.ImageName !== 'none' && buildTeacherImageUrl(selected.ImageName) && <img src={buildTeacherImageUrl(selected.ImageName)} alt="" className="h-6 w-6 flex-shrink-0 rounded-full object-cover" />}
                  <span className="ml-3 block truncate">{selected.Name}</span>
                </span>
                <span className="pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-2">
                  <ChevronUpDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                </span>
              </Listbox.Button>

              <Transition
                show={open}
                as={Fragment}
                leave="transition ease-in duration-100"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Listbox.Options className="absolute z-10 m-0 mt-1 max-h-56 w-11/12 overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                  {props.teachers.map((teach) => (
                    <Listbox.Option
                      key={teach.TeacherID}
                      className={({ active }) =>
                        classNames(
                          active ? 'text-white bg-indigo-600' : 'text-gray-900',
                          'relative cursor-default select-none py-2 pl-3 pr-9 -ml-10 list-none'
                        )
                      }
                      value={teach}
                    >
                      {({ selected, active }) => (
                        <>
                          <div className="flex items-center">
                            {buildTeacherImageUrl(teach.ImageName || teach.imageName) ? (
                              <img src={buildTeacherImageUrl(teach.ImageName || teach.imageName)} alt="" className="h-6 w-6 flex-shrink-0 rounded-full object-cover" />
                            ) : (
                              <div className="h-6 w-6 flex-shrink-0 rounded-full bg-slate-200" />
                            )}
                            <span
                              className={classNames(selected ? 'font-semibold' : 'font-normal', 'ml-3 block truncate')}
                            >
                              {teach.Name}
                            </span>
                          </div>

                          {selected ? (
                            <span
                              className={classNames(
                                active ? 'text-white' : 'text-indigo-600',
                                'absolute inset-y-0 right-0 flex items-center pr-4'
                              )}
                            >
                              <CheckIcon className="h-5 w-5" aria-hidden="true" />
                            </span>
                          ) : null}
                        </>
                      )}
                    </Listbox.Option>
                  ))}
                </Listbox.Options>
              </Transition>
            </div>
          </>
        )}
      </Listbox>
    </div>
  )
}
